import PortableText from '@otovo/shared/components/Sanity/PortableTextComponents';
import { Sanity$RowContent } from '@otovo/shared/types/sanityTypes';

type Props = {
  children: Sanity$RowContent[] | string;
};

const HeroHeading = ({ children }: Props) => {
  return (
    <h1 className="mb-3 block text-3xl font-semibold text-balance text-heading md:text-5xl">
      {typeof children === 'string' ? (
        children
      ) : (
        <PortableText
          components={{
            marks: {
              gradient: ({
                children: content,
              }: {
                children: React.ReactNode;
              }) => (
                <span className="bg-linear-to-tr from-[#EA5634] to-[#FBC739] bg-clip-text text-transparent">
                  {content}
                </span>
              ),
            },
            block: {
              normal: ({ children: content }) => <span>{content}</span>,
            },
          }}
          value={children}
        />
      )}
    </h1>
  );
};

export default HeroHeading;
